//提示信息
export const TIPSINFO = {
  deleteTipsInfo: "您确定要删除此信息吗？",
  modelDeploy: "您确定要部署此模型吗？",
  modelDeploySuccess: "此模型部署成功，请到流程定义中查找",
  deleleInfo: "删除信息成功",
  processToModel: "流程定义转换流程模型成功"
}

export default {
  TIPSINFO
}



// WEBPACK FOOTER //
// ./src/utils/tipsInfo.js